import { PUNCH_ADD, PUNCH_OUT } from '../actions/index';
//import moment from 'moment';

export default function(state = {}, action) {
  switch(action.type) {
    case PUNCH_ADD:
      return {
        ...state,
        [action.id]: {
          id: action.id,
          serverID: 'Syncing',
          ...action.punch
        },
      }
    case PUNCH_OUT:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          punchOut: action.punchOut
        },
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_punches.js